
export const formatFeatureValue = (quantity: number, measurementUnit: string): { number: string; unit: string, more:string} => {
    const unitMap: Record<string, string> = {
        'file': 'шт.',
        'text_page': 'стр.',
        'time': 'мин.',
    }

    const unit = unitMap[measurementUnit] || measurementUnit
    let number:string = String(quantity)
    let more = ''

    if (quantity >= 9999){
        number = '9999'
        more = 'более'
    }

    if (quantity == 0){
        number = '-'
    }
    
    return { number: number, unit: unit, more:more }
}

